import { getEditor, isEnabled } from '../composables/editorsMap';
import { textPalettes } from '../composables/utils';
import ColorsOptions from '../menuItemComponents/ColorsOptions.vue';
import { Palette } from 'lucide-vue-next';
export const getColorOptions = (id: string) => {
  const editor = getEditor(id)?.value;

  return {
    disabled: !isEnabled(id, 'color'),
    icon: Palette,
    title: 'צבע טקסט',
    type: 'select',
    component: ColorsOptions,
    props: { palettes: textPalettes, type: 'textStyle' },
    action: color =>
      color
        ? editor?.chain().focus().setColor(color).run()
        : editor?.chain().focus().unsetColor(color).run(),
    isActive: () => getEditor(id).value?.isActive('color'),
  };
};
